<h5 mat-dialog-title i18n>Create Template</h5>
<div mat-dialog-content>
  <p i18n>Templates are predefined areas and items that can be added to a new quote. Each template has a unique name that identifies it.</p>
  <form #templateForm="ngForm" (ngSubmit)="saveTemplate(templateForm)">
    <div class="form-group row">
      <label for="quoteTemplate_Name" class="col-sm-4 col-form-label" i18n>Template Name</label>
      <div class="col-sm-8">
        <input class="form-control" name="quoteTemplate_Name" id="quoteTemplate_Name"
               [(ngModel)]="data.quoteTemplate_Name" #quoteTemplate_Name="ngModel">
      </div>
    </div>
    <div class="form-group row">
      <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Submit</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
  </form>
</div>
